import React from 'react';
import { Topbar } from './components/Topbar';
import { Hero } from './components/Hero';
import { Agitation } from './components/Agitation';
import { RevealSection } from './components/RevealSection';
import { ProductReveal } from './components/ProductReveal';
import { LabelSection } from './components/LabelSection';
import { Timeline } from './components/Timeline';
import { Diferenciales } from './components/Diferenciales';
import { Objeciones } from './components/Objeciones';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-espresso font-sans text-white" data-id="element-0">
      <Topbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Agitation data-id="element-4" />
        <RevealSection data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <LabelSection data-id="element-7" />
        <Timeline data-id="element-8" />
        <Diferenciales data-id="element-9" />
        <Objeciones data-id="element-10" />
        <FinalCta data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}